module.exports = __webpack_public_path__ + "img/icon-apto.5c50cc58.svg";